export default "__VITE_ASSET__Dsjrs6fK__"